<template>
  <section>
    <div class="send-plane d-flex position-fixed">
      <img src="@/assets/icons/send.svg">
    </div>
    <div class="circles">
      <div class="circle light" />
      <div class="circle yellow" />
      <div class="circle blue" />
      <div class="circle red" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'SendActivationLinkAround'
}
</script>

<style scoped>

</style>
